export default (function (_ref) {
  var service = _ref.service,
      request = _ref.request,
      serviceForMock = _ref.serviceForMock,
      requestForMock = _ref.requestForMock,
      mock = _ref.mock,
      faker = _ref.faker,
      tools = _ref.tools;
  return {
    giftCodeLevelList: function giftCodeLevelList(data) {
      return request({
        url: '/gift_code/giftCodeLevelList',
        method: 'get',
        data: data
      });
    },
    giftCodeLevelSave: function giftCodeLevelSave(data) {
      return request({
        url: '/gift_code/giftCodeLevelSave',
        method: 'post',
        data: data
      });
    },
    giftCodeLevelDelete: function giftCodeLevelDelete(data) {
      return request({
        url: '/gift_code/giftCodeLevelDelete',
        method: 'post',
        data: data
      });
    },
    giftCodeList: function giftCodeList(data) {
      return request({
        url: '/gift_code/giftCodeList',
        method: 'get',
        data: data
      });
    },
    recycleGiftCode: function recycleGiftCode(data) {
      return request({
        url: '/gift_code/recycleGiftCode',
        method: 'post',
        data: data
      });
    },
    generateGiftCodes: function generateGiftCodes(data) {
      return request({
        url: '/gift_code/generateGiftCodes',
        method: 'post',
        data: data
      });
    },
    editGiftCode: function editGiftCode(data) {
      return request({
        url: '/gift_code/editGiftCode',
        method: 'post',
        data: data
      });
    },
    delGiftCode: function delGiftCode(data) {
      return request({
        url: '/gift_code/delGiftCode',
        method: 'post',
        data: data
      });
    },
    studentList: function studentList(data) {
      return request({
        url: '/studentList',
        method: 'get',
        data: data
      });
    },
    activeGiftCode: function activeGiftCode(data) {
      return request({
        url: '/activeGiftCode',
        method: 'post',
        data: data
      });
    },
    delStudent: function delStudent(data) {
      return request({
        url: '/delStudent',
        method: 'post',
        data: data
      });
    },
    updateStudent: function updateStudent(data) {
      return request({
        url: '/updateStudent',
        method: 'post',
        data: data
      });
    },
    configFileList: function configFileList(data) {
      return request({
        url: '/configFileList',
        method: 'get',
        data: data
      });
    },
    delStudentConifg: function delStudentConifg(data) {
      return request({
        url: '/del-student-config',
        method: 'post',
        data: data
      });
    }
  };
});